export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY || '';
